const en = {
  app_name: "Univers Libertin",
  app_tagline: "Your safe, discreet, and caring space.",
  app_badge: "Consenting Adults · Community",
  loading: "Loading...",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  close: "close",
  send: "Send",
  search: "Search",
  go: "Go",
  confirm_delete: "Delete this post?",
  no_results: "No results found.",
  error_generic: "Internal error.",
  footer_trust: "Total privacy · AI moderation · Your data is never sold",

  nav_feed: "Feed",
  nav_directory: "Directory",
  nav_encounters: "Encounters",
  nav_places: "Places",
  nav_messages: "Messages",
  nav_premium: "Premium",
  nav_profile: "Profile",
  nav_blog: "Blog",
  nav_logout: "Log out",

  age_gate_title: "Adults only",
  age_gate_desc: "Univers Libertin is a community platform for consenting adults. Access is strictly reserved for people aged 18 and over.",
  age_gate_confirm: "I certify I am 18 or older — Enter",
  age_gate_deny: "I am under 18 — Leave",

  charter_title: "Consent charter",
  charter_desc: "Commit to respecting these fundamental principles to access the community.",
  charter_accept_all: "I accept the charter — Continue",
  charter_accept_pending: "Accept all 3 commitments",
  charter_rule_consent_title: "Absolute consent",
  charter_rule_consent_desc: "I confirm I am of legal age (18+). I commit to respecting everyone's consent at all times. A 'no' or silence is never a 'yes'. No pressure, insistence, or manipulation will be tolerated.",
  charter_rule_discretion_title: "Total confidentiality",
  charter_rule_discretion_desc: "What happens on Univers Libertin stays on Univers Libertin. I will never share the identity, photos, information, or activities of another member without their explicit consent. No outing.",
  charter_rule_respect_title: "Respect & Kindness",
  charter_rule_respect_desc: "I respect everyone's limits, practices, and choices without judgment. No body-shaming, slut-shaming, kink-shaming, or discrimination of any kind. Everyone is free in their desires and boundaries.",
  charter_read_again: "← Read the charter again",

  auth_login: "Login",
  auth_signup: "Sign up",
  auth_pseudo: "Username",
  auth_pseudo_placeholder: "Your discreet username",
  auth_pseudo_hint: "Choose a username — never your real name.",
  auth_email: "Email",
  auth_email_placeholder: "your@email.com",
  auth_password: "Password",
  auth_password_placeholder: "Minimum 8 characters",
  auth_login_btn: "Log in",
  auth_signup_btn: "Join the community",
  auth_logging_in: "Logging in...",
  auth_signing_up: "Creating...",
  auth_signup_success: "Account created! You can now log in.",

  feed_placeholder: "How are you feeling? Share safely...",
  feed_publish: "Post",
  feed_analyzing: "Analyzing...",
  feed_char_count: "{count}/2000 — AI moderated",
  feed_empty: "No posts yet. Be the first to share.",
  feed_moderation_warning: "Your message does not comply with our charter.",

  mood_neutral: "Neutral",
  mood_happy: "Happy",
  mood_sad: "Sad",
  mood_anxious: "Anxious",
  mood_grateful: "Grateful",
  mood_angry: "Angry",
  mood_hopeful: "Hopeful",

  directory_title: "Directory",
  directory_desc: "Explore the community discreetly.",
  directory_search_placeholder: "Search by city...",
  directory_filter_all: "All",
  directory_no_profiles: "No profiles found.",
  directory_send_message: "Send a message →",
  directory_looking_for: "Looking for:",
  directory_interests: "Interests:",

  filter_gender: "Gender",
  filter_orientation: "Orientation",
  filter_status: "Status",
  filter_all_genders: "All",
  filter_all_orientations: "All",
  filter_all_statuses: "All",

  gender_unset: "Not specified",
  gender_man: "Man",
  gender_woman: "Woman",
  gender_nb: "Non-binary",
  gender_other: "Other",

  orientation_unset: "Not specified",
  orientation_hetero: "Straight",
  orientation_bi: "Bi",
  orientation_gay: "Gay",
  orientation_lesbian: "Lesbian",
  orientation_pan: "Pan",
  orientation_curious: "Curious",
  orientation_other: "Other",

  status_unset: "Not specified",
  status_solo: "Solo",
  status_couple: "In a couple",
  status_open: "Open relationship",
  status_poly: "Polyamorous",
  status_other: "Other",

  level_unset: "Not specified",
  level_curious: "Curious",
  level_beginner: "Beginner",
  level_experienced: "Experienced",
  level_confirmed: "Advanced",

  profile_title: "My profile",
  profile_desc: "Customize your presence. Only your username is visible, never your email.",
  profile_avatar: "Avatar",
  profile_photos: "Profile photos",
  profile_photos_hint: "You can blur some photos. Go Premium to upload more.",
  profile_identity: "Identity",
  profile_display_name: "Display name",
  profile_display_name_placeholder: "Nickname",
  profile_bio: "Bio",
  profile_bio_placeholder: "Describe yourself, your desires, what attracts you...",
  profile_city: "City",
  profile_city_placeholder: "Your city",
  profile_age: "Age",
  profile_experience: "Experience",
  profile_department: "Department",
  profile_department_unset: "Not specified",
  profile_region: "Region",
  profile_region_unset: "Not specified",
  profile_looking_for: "Looking for",
  profile_interests: "Interests",
  profile_interests_add: "Add...",
  profile_boundaries: "My limits & safe words",
  profile_boundaries_placeholder: "What you don't want, your clear limits, your safe word...",
  profile_boundaries_hint: "Your limits are visible to other members. They will be respected.",
  profile_privacy: "Privacy",
  profile_visible: "Visible in directory",
  profile_visible_desc: "Disable to hide your profile.",
  profile_show_age: "Show my age",
  profile_show_age_desc: "Your age will be visible on your profile.",
  profile_allow_messages: "Accept private messages",
  profile_allow_messages_desc: "Allow other members to message you.",
  profile_save: "Save my profile",
  profile_saving: "Saving...",
  profile_saved: "Profile saved!",

  looking_discussions: "Discussions",
  looking_friendship: "Libertine friendship",
  looking_soft: "Soft encounters",
  looking_parties: "Private parties",
  looking_couple: "Couple play",
  looking_solo: "Solo play",
  looking_swinging: "Swinging",
  looking_melangisme: "Soft swinging",
  looking_voyeur: "Voyeurism/Exhib",
  looking_bdsm: "BDSM",
  looking_poly: "Polyamory",
  looking_clubs: "Club outings",

  encounters_title: "Encounters",
  encounters_desc: "Propose or join events.",
  encounters_propose: "+ Propose",
  encounters_new: "New proposal",
  encounters_title_placeholder: "Title (e.g.: Soft libertine party in London)",
  encounters_desc_placeholder: "Describe the event, the vibe, your expectations...",
  encounters_category: "Category",
  encounters_who: "Who can join",
  encounters_city: "City",
  encounters_date: "Date & time",
  encounters_max: "Max participants",
  encounters_location: "Location (club name, address, link...)",
  encounters_dresscode: "Dress code (optional)",
  encounters_online: "Online",
  encounters_rules: "Event rules (optional)",
  encounters_publish: "Publish proposal",
  encounters_creating: "Creating...",
  encounters_created: "Proposal created!",
  encounters_join: "Join →",
  encounters_join_placeholder: "Introduce yourself briefly...",
  encounters_request_sent: "Request sent!",
  encounters_empty: "No encounters yet.",
  encounters_open: "Open",
  encounters_full: "Full",
  encounters_places: "{count}/{max} spots",
  encounters_by: "by {name} · {date}",
  encounters_date_flexible: "Flexible date",

  cat_all: "All",
  cat_soiree: "Private party",
  cat_club: "Club",
  cat_meetup: "Meetup",
  cat_afterwork: "After-work",
  cat_sauna: "Sauna / Spa",
  cat_voyage: "Travel",
  cat_weekend: "Weekend",
  cat_online: "Online",
  cat_couple_seek: "Couple seeking",
  cat_soft: "Soft / Discovery",
  cat_discussion: "Discussion",
  cat_other: "Other",

  who_all: "Open to all",
  who_couples: "Couples only",
  who_men: "Men only",
  who_women: "Women only",
  who_couples_women: "Couples & women",
  who_verified: "Verified profiles",

  places_title: "Places",
  places_desc: "Community-recommended libertine venues.",
  places_add: "+ Add",
  places_suggest: "Suggest a place",
  places_name: "Place name",
  places_name_desc: "Describe the place, the vibe, what makes it special...",
  places_category: "Category",
  places_city: "City",
  places_department: "Department",
  places_department_select: "Select...",
  places_region: "Region",
  places_region_auto: "Auto (from department)",
  places_region_all: "All France",
  places_price: "Price",
  places_address: "Full address (optional)",
  places_website: "Website (optional)",
  places_features: "Amenities & features",
  places_submit: "Submit",
  places_submitting: "Sending...",
  places_submitted: "Place submitted!",
  places_empty: "No places found.",
  places_reviews: "reviews",
  places_review_cta: "Leave a review →",
  places_review_general: "Overall",
  places_review_ambiance: "Ambiance",
  places_review_respect: "Respect",
  places_review_hygiene: "Hygiene",
  places_review_placeholder: "Your experience...",
  places_review_publish: "Publish",
  places_review_published: "Review published!",
  places_verified: "✓ Verified",
  places_search_placeholder: "Search by city...",

  pcat_all: "All",
  pcat_club: "Libertine club",
  pcat_sauna: "Sauna / Spa",
  pcat_bar: "Bar",
  pcat_hotel: "Hotel",
  pcat_beach: "Beach / Nature",
  pcat_camping: "Camping",
  pcat_restaurant: "Restaurant",
  pcat_association: "Association",
  pcat_boutique: "Shop",
  pcat_online: "Online",
  pcat_other: "Other",

  price_unset: "Not specified",
  price_free: "Free",
  price_low: "€ (< 30€)",
  price_mid: "€€ (30-80€)",
  price_high: "€€€ (> 80€)",

  messages_title: "Messages",
  messages_desc: "Your private and discreet conversations.",
  messages_empty: "No conversations yet.",
  messages_go_directory: "Go to directory →",
  messages_conversation: "Conversation",
  messages_start: "Start of the conversation. Be respectful and kind.",
  messages_placeholder: "Your message...",
  messages_not_allowed: "This member does not accept private messages.",
  messages_moderation: "Message does not comply with the charter.",

  premium_title: "Go Premium",
  premium_desc: "Unlock all features for the full experience.",
  premium_current: "Current",
  premium_choose: "Choose {name}",
  premium_manage: "Manage subscription",
  premium_redirecting: "Redirecting...",
  premium_success: "Welcome to {plan}! Enjoy all your new features.",
  premium_footer: "Secure payment via Stripe · Cancel anytime · No commitment",
  premium_active_until: "Your {name} subscription is active until {date}.",
  plan_free: "Free",
  plan_premium: "Premium",
  plan_vip: "VIP",
  plan_month: "/month",

  photos_drop: "Click or drop an image (JPG, PNG, WebP · max 5 MB)",
  photos_count: "{current}/{max} photos",
  photos_uploading: "Uploading...",
  photos_limit: "Photo limit reached ({max}, {plan} plan).",
  photos_confirm_delete: "Delete this photo?",

  visitors_title: "Who visited my profile",
  visitors_count: "recent visits",
  visitors_upsell: "Go Premium to see who is interested in you.",
  visitors_none: "No recent visits.",
  nav_pro: "Pro",
  nav_visitors: "Visitors",
  pro_title: "Pro Dashboard",
  pro_desc: "Manage your claimed venues.",
  pro_claim: "This is my venue",
  pro_no_places: "No claimed venues yet.",
  pro_pending: "Pending claims",
  spotlight_label: "Spotlight",
  spotlight_buy: "⭐ Boost 24h — €2.99",
  spotlight_active: "Highlighted",

};

export default en;
